import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Hide the inline splash once React has painted
requestAnimationFrame(() => {
  const splash = document.getElementById("qgt-splash");
  if (splash) {
    splash.classList.add("hidden");
    setTimeout(() => splash.remove(), 400);
  }
});
